import { setAccessToken } from './api';

export function errorManager(error){
    if (error.response) {
        error={
            message:error.response.data.Message,
            code:error.response.status,
            data:error.response.headers
        }
    } 
    else if (error.request) {
        error={
            message:error.message,
            code:-1,
            data:error.request
        }
    } 
    else {
        error={
            message:error.message,
            code:-2,
            data:error
        }
    }

    setAccessToken();
    
    return error;
}